import React, { useMemo } from "react";
import {
  ObjectStatusCssClasses,
  ObjectStatusTitles,
  ObjectDeletedTitles,
  ObjectActiveTitles,
  ObjectRegisterStatusTitles,
  ObjectRegisterStatusCssClasses
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";



const setRow = (row) => {

  if (row.isActive !== undefined && row.isDeleted !== undefined && row.registerStatus !== undefined) {
    return (
      <>
        < span
          className={`label label-lg label-light-${ObjectStatusCssClasses[(+!row.isActive)]
            } label-inline`
          }
        >
          <FormattedMessage id={ObjectActiveTitles[(+!row.isActive)]} />
        </span >
        {"   "}
        < span
          className={`label label-lg label-light-${ObjectStatusCssClasses[(+!!row.isDeleted)]
            } label-inline`
          }
        >
          <FormattedMessage id={ObjectDeletedTitles[(+!!row.isDeleted)]} />
        </span >
        {"   "}
        < span
          className={`label label-lg label-light-${ObjectRegisterStatusCssClasses[(getValue(row.registerStatus))]
            } label-inline`
          }
        >
          <FormattedMessage id={ObjectRegisterStatusTitles[(getValue(row.registerStatus))]} />
        </span >

      </>
    )
  }
  else if (row.isActive !== undefined) {
    return (
      <>
        < span
          className={`label label-lg label-light-${ObjectStatusCssClasses[(+!row.isActive)]
            } label-inline`
          }
        >
          <FormattedMessage id={ObjectActiveTitles[(+!row.isActive)]} />
        </span >
        {/* {"   "}
        < span
          className={`label label-lg label-light-${ObjectRegisterStatusCssClasses[(getValue(row.registerStatus))]
            } label-inline`
          }
        >
          <FormattedMessage id={ObjectRegisterStatusTitles[(getValue(row.registerStatus))]} />
        </span > */}
      </>
    )
  }
  else if (row.isDeleted !== undefined) {
    return (
      <>
        < span
          className={`label label-lg label-light-${ObjectStatusCssClasses[(+!!row.isDeleted)]
            } label-inline`
          }
        >
          <FormattedMessage id={ObjectStatusTitles[(+!!row.isDeleted)]} />
        </span >
        {/* {"   "}
        < span
          className={`label label-lg label-light-${ObjectRegisterStatusCssClasses[(getValue(row.registerStatus))]
            } label-inline`
          }
        >
          <FormattedMessage id={ObjectRegisterStatusTitles[(getValue(row.registerStatus))]} />
        </span > */}
      </>
    )
  }
  else if (row.registerStatus !== undefined) {
    return (
      <>
        < span
          className={`label label-lg label-light-${ObjectRegisterStatusCssClasses[(getValue(row.registerStatus))]
            } label-inline`
          }
        >
          <FormattedMessage id={ObjectRegisterStatusTitles[(getValue(row.registerStatus))]} />
        </span >
      </>
    )
  }
}

const setRegisterRow = (row) => {
  if (row.registerStatus === undefined || row.registerStatus === "100" || row.registerStatus === 100) {
    return (
      <>
        < span
          className={`label label-lg label-light-${ObjectRegisterStatusCssClasses[(row.registerStatus)]
            } label-inline`
          }
        >
          <FormattedMessage id="MODULES.DORM.ROOM.RESERVATION.REPORT.STATUS1" />
        </span >
      </>
    )
  }
  else {
    return (
      <>
        < span
          className={`label label-lg label-light-${ObjectRegisterStatusCssClasses[(row.registerStatus)]
            } label-inline`
          }
        >
          <FormattedMessage id={ObjectRegisterStatusTitles[(row.registerStatus)]} />
        </span >
      </>
    )
  }

}

const getValue = (type) => {
  if (type) {
    if (type === "Incomplete" || type === "1") return 1;
    if (type === "Expired" || type === "2") return 2;
    if (type === "Rejected" || type === "3") return 3;
    if (type === "Checking" || type === "4") return 4;
    if (type === "Approved" || type === "5") return 5;
  } else return 0;
};

export const StatusColumnFormatter = (cellContent, row) => setRow(row);

export const indexN = (cellContent, row, index) => {
  return (<div>{index + 1}</div>)
}

export const RegisterStatusColumnFormatter = (cellContent, row) => setRegisterRow(row);